import { tg } from "../telegram";

export type Tab = "mine" | "epochs" | "referrals" | "wallet" | "leaderboard";

const TABS: Array<{ id: Tab; label: string; icon: string }> = [
  { id: "mine", label: "Mine", icon: "◆" },
  { id: "epochs", label: "Epochs", icon: "◔" },
  { id: "referrals", label: "Invite", icon: "⇄" },
  { id: "wallet", label: "Wallet", icon: "▣" },
  { id: "leaderboard", label: "Top", icon: "≡" },
];

export function TabBar({ active, onChange }: { active: Tab; onChange: (t: Tab) => void }) {
  return (
    <nav
      className="fixed inset-x-0 bottom-0 z-10 border-t border-white/5 bg-bg-2/95 backdrop-blur"
      style={{ paddingBottom: "env(safe-area-inset-bottom)" }}
    >
      <ul className="mx-auto flex max-w-md">
        {TABS.map((t) => {
          const isActive = t.id === active;
          return (
            <li key={t.id} className="flex-1">
              <button
                className={`flex w-full flex-col items-center gap-0.5 py-2 text-[11px] outline-none ${
                  isActive ? "text-brand" : "text-hint"
                }`}
                onClick={() => {
                  if (!isActive) tg.haptic.select();
                  onChange(t.id);
                }}
                aria-current={isActive ? "page" : undefined}
              >
                <span className="text-lg leading-none">{t.icon}</span>
                {t.label}
              </button>
            </li>
          );
        })}
      </ul>
    </nav>
  );
}
